import WidgetNivoLine from "./Widget.nivo.line";
import WidgetNivoBar from "./Widget.nivo.bar";

const NivoWidgets = {
    Line: WidgetNivoLine,
    Bar: WidgetNivoBar
}

export default NivoWidgets;